const WEBP_URL_SUFFIX = '/format:webp';

export {
  WEBP_URL_SUFFIX,
}
